import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { COMPLIAN_TYPE } from '../../../helper/constants';

export interface DialogData {
  complianceType: string;
  facilityName: string;
  imageUrl: string;
}

@Component({
  selector: 'app-compliance-dialog',
  templateUrl: 'compliancedialog.component.html',
  styleUrls: ['./compliancedialog.component.css']
})

export class ComplianceDialogComponent implements OnInit {

  Red: string;
  Yellow: string;
  Green: string;
  red = 'assets/images/red.svg';
  yellow = 'assets/images/yellow.svg';
  green = 'assets/images/green.svg';
  redSelected = 'assets/images/redselected.svg';
  yellowSelected = 'assets/images/yellowselected.svg';
  greenSelected = 'assets/images/greenselected.svg';
  complainceTypes = COMPLIAN_TYPE;
  selectedComplaince: string;
  complainceStatus: boolean;
  iAgree = true;
  imageSelected: string;

  constructor(private router: Router,
    public dialogRef: MatDialogRef<ComplianceDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) { }

  onNoClick(): void {
    if (this.data.complianceType === COMPLIAN_TYPE.No_Selection) {
      this.dialogRef.close();
    } else {
      this.dialogRef.close({ status: this.complainceStatus, value: this.data.complianceType });
    }
  }
  ngOnInit() {
    this.Red = this.red;
    this.Yellow = this.yellow;
    this.Green = this.green;
    this.complainceStatus = false;
    this.selectedComplaince = this.data.complianceType;
    this.imageSelected = this.data.imageUrl;


    if (this.data.complianceType !== 'Select Readiness Status') {
      this.onOptionClick(this.data.complianceType);
    }
  }

  onOptionClick = (value: string) => {
    if (value === 'Ready') {

      this.Green = this.greenSelected;
      this.Red = this.red;
      this.Yellow = this.yellow;
    } else if (value === 'Not Ready') {
      this.Green = this.green;
      this.Red = this.redSelected;
      this.Yellow = this.yellow;
    } else if (value === 'Medium') {
      this.Green = this.green;
      this.Red = this.red;
      this.Yellow = this.yellowSelected;
    }
    this.selectedComplaince = value;
    this.complainceStatus = true;
  }

  onDone = () => {
    this.dialogRef.close({ status: this.complainceStatus, value: this.selectedComplaince });
  }
}
